module.exports = __webpack_public_path__ + "static/img/poster.3dd06136.png";